module.exports = __webpack_public_path__ + "static/DigirytePods-banner-3b6ec3d3500ea907786fbd435ed0deb6.png";